import Table from "../../../Components/Table/Table";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";

export default function WithdrawTable({
  rows,
  accLoading,
  isLoadingMore,
}) {
  return (
    <div className="w-full flex flex-col gap-5">
      <div className="w-full">
        <Table
          isEnglish={[0, 1, 2, 3]}
          columns={[
            { key: "dateReq", label: "تاریخ درخواست" },
            { key: "transId", label: "کد تراکنش" },
            { key: "reqAmount", label: "مبلغ درخواستی" },
            { key: "dateDone", label: "تاریخ تکمیل" },
            {
              key: "status",
              label: "وضعیت تراکنش",
              render: (value) =>
                value === "approved" ? (
                  <StatusColorful
                    SVGName="tick"
                    text="تکمیل شده"
                    className="w-24"
                    color="green"
                  />
                ) : value === "pending" ? (
                  <StatusColorful
                    SVGName="stall"
                    text="در انتظار"
                    className="w-24"
                    color="yellow"
                  />
                ) : value === "rejected" ? (
                  <StatusColorful
                    SVGName="failed"
                    text="رد شده"
                    className="w-24"
                    color="red"
                  />
                ) : (
                  <StatusColorful
                    SVGName="stall"
                    text="نامشخص"
                    className="w-24"
                    color="gray"
                  />
                ),
            },
          ]}
          data={rows}
        />
      </div>
      {accLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {isLoadingMore && rows.length > 0 && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری بیشتر</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {!accLoading && rows.length === 0 && (
        <div className="w-full flex justify-center items-center flex-col gap-5">
          <p className="text-zi-text-light dark:text-zi-text-dark text-sm sm:text-base">
            موردی برای نمایش وجود ندارد
          </p>
          <SVG name="noData" classname="w-24 fill-cyan-500" />
        </div>
      )}
    </div>
  );
}
